import { useMemo } from 'react';
import { useAssetPrices, useAssetsIcons } from '@/shared/api';
import {
  MARKET_ASSETS_QTY,
  MARKET_BASE_ASSET,
  MARKET_TAB_FILTER,
  type MarketTab,
} from '../config/marketTabs';
import { toMarketAsset, type MarketAsset } from './toMarketAsset';

const useMarketAssets = (tab: MarketTab) => {
  const { assetsIconsData, isAssetsIconsLoading } = useAssetsIcons();
  const {
    data: pricesData,
    isLoading: isPricesLoading,
    isError,
  } = useAssetPrices({
    asset: MARKET_BASE_ASSET,
    filter: MARKET_TAB_FILTER[tab],
  });

  const assets: Array<MarketAsset> = useMemo(() => {
    if (!pricesData) return [];

    return pricesData.assets
      .slice(0, MARKET_ASSETS_QTY)
      .map(asset =>
        toMarketAsset(asset, pricesData.basePrecission, assetsIconsData?.value)
      );
  }, [pricesData, assetsIconsData]);

  return {
    assets,
    baseAsset: MARKET_BASE_ASSET,
    isLoading: isPricesLoading || isAssetsIconsLoading,
    isError,
  };
};

export { useMarketAssets };
